import css from './VlogSkeleton.module.css';

const VlogSkeleton = ({ count = 4, slidesToShow = 4 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          className={css.shortCard} 
          key={index}
          style={{ flex: `0 0 ${100 / slidesToShow}%` }}
        >
          <div className={css.shortThumbnailWrapper}>
            <div className={css.videoSkeleton} />
          </div>
          <div className={css.shortCardInfo}>
            <div className={css.categorySkeleton} />
            <div className={css.titleSkeleton} />
            <div className={css.descSkeleton} />
          </div>
        </div>
      ))}
    </>
  );
};

const FeaturedVlogSkeleton = () => {
  return (
    <div className={css.phoneFrame}>
      <div className={css.featuredVideoSkeleton} />
    </div>
  );
};

export { VlogSkeleton, FeaturedVlogSkeleton };